module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Notification center","settingsTitle":"Notification settings","empty":"No notifications yet"}}')
  delete Component.options._Ctor
}
